{
    "Accessibility Menu": "Menu dostępności",
    "Reset settings": "Reset ustawień",
    "Close": "Zamknij",
    "Content Adjustments": "Dostosowanie zawartości",
    "Adjust Font Size": "Dostosuj rozmiar czcionki",
    "Highlight Title": "Podświetl tytuły",
    "Highlight Links": "Podświetl linki",
    "Readable Font": "Czytelna czcionka",
    "Color Adjustments": "Dostosowanie kolorów",
    "Dark Contrast": "Ciemny kontrast",
    "Light Contrast": "Jasny kontrast",
    "High Contrast": "Wysoki kontrast",
    "High Saturation": "Wysoka saturacja",
    "Low Saturation": "Niska saturacja",
    "Monochrome": "Monochromatyczność",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Pomoce wizualne i nawigacyjne",
    "Additional Tools": "Dodatkowe narzędzia",
    "Reading Guide": "Pomocnik czytania",
    "Stop Animations": "Wstrzymaj animacje",
    "Big Cursor": "Duży kursor",
    "Screen Reader": "Czytnik ekranu",
    "Hide Images": "Ukryj obrazy",
    "Image Tooltips": "Podpowiedzi obrazów",
    "Page Structure": "Struktura strony",
    "Super Focus": "Super Focus",
    "Magnifier": "Lupa",
    "Increase Font Size": "Zwiększ rozmiar czcionki",
    "Decrease Font Size": "Zmniejsz rozmiar czcionki",
    "Letter Spacing": "Odstępy między literami",
    "Line Height": "Wysokość wierszy",
    "Font Weight": "Pogrubiona czcionka",
    "Dyslexia Font": "Czcionka dla dyslektyków",
    "Language": "Język",
    "Open Accessibility Menu": "Otwórz menu dostępności",
    "Accessibility Profiles": "Profile dostępności",
    "Seizure Safe Profile": "Profil bezpieczny dla epileptyka",
    "Stops animations and reduces color saturation.": "Zatrzymuje animacje i redukuje nasycenie kolorów.",
    "Blind Profile": "Profil dla niewidomych",
    "Activates the screen reader for auditory navigation.": "Aktywuje czytnik ekranu do nawigacji dźwiękowej.",
    "Visually Impaired Profile": "Profil dla słabowidzących",
    "Enhances contrast and readability for low vision.": "Poprawia kontrast i czytelność dla osób słabowidzących.",
    "ADHD Friendly Profile": "Profil przyjazny ADHD",
    "Reduces distractions for better focus.": "Zmniejsza rozproszenia dla lepszego skupienia.",
    "Cognitive & Learning Profile": "Profil poznawczy i edukacyjny",
    "Helpful tools for reading and comprehension.": "Pomocne narzędzia do czytania i rozumienia.",
    "Motor Impaired Profile": "Profil dla osób z niepełnosprawnością ruchową",
    "Optimizes the site for keyboard-only navigation.": "Optymalizuje stronę pod kątem nawigacji tylko klawiaturą.",
    "Headings": "Nagłówki",
    "Landmarks": "Punkty orientacyjne",
    "Links": "Linki",
    "Focus element": "Skup się na elemencie",
    "Visit link": "Odwiedź link"
}